import { lazy } from 'react';

// project imports
import Loadable from 'src/components/Loadable';
import GuestGuard from './GuestGuard';

const Landing = Loadable(lazy(() => import('src/views/Landing')));
const LoginView = Loadable(lazy(() => import('src/views/auth/LoginView')));
const ForgotView = Loadable(lazy(() => import('src/views/auth/ForgotView')));
const ResetView = Loadable(lazy(() => import('src/views/auth/ResetView')));
const TermsView = Loadable(lazy(() => import('src/views/auth/TermsView')));
const NotFoundView = Loadable(
  lazy(() => import('src/views/errors/NotFoundView'))
);

// ==============================|| PULIC ROUTING ||============================== //

const PublicRoutes = {
  path: '/',
  element: <GuestGuard />,
  children: [
    {
      path: '/home/:sectionId',
      element: <Landing />
    },
    {
      path: '/home',
      element: <Landing />
    },
    {
      path: '/login',
      element: <LoginView />
    },
    {
      path: '/forgot',
      element: <ForgotView />
    },
    {
      path: '/reset',
      element: <ResetView />
    },
    {
      path: '/terms',
      element: <TermsView />
    },
    {
      path: '/404',
      element: <NotFoundView />
    }
    //{
    //  path: '/register',
    //  element: lazy(import('src/views/auth/RegisterView'))
    // },
  ]
};

export default PublicRoutes;
